export const DEFAULT_CONFIG = {
    minPlayProbability: 0.62,
    strongProbability: 0.7,
    minSecondsRemaining: 150,
    minRawScore: 28,
    marketUpPrice: null,
    minEdge: 0.04,
    bookLevels: 20,
    bookSamples: 3,
    bookSampleDelaySeconds: 1.0,
    minimumCalibrationSamples: 12,
    minimumSimilarSamples: 8,
    simulatedStartingPool: 200,
    maxIndividualBuy: 20,
    minimumIndividualBuy: 1,
    sizingMinEdge: 0.03,
    kellyFraction: 0.25,
};
//# sourceMappingURL=config.js.map